import React              from 'react';
import { useTranslation } from 'react-i18next';
import DV                 from 'ts-data-validator';

import Alerts                   from './components/alerts';
import Backdrop                 from './components/containers/Backdrop';
import BottomMenu               from './components/bottom-menu';
import Breadcrumbs              from './components/breadcrumbs';
import {
  CallMeSidebar,
  ProfileSidebar,
}                               from './components';
import CookieNotice             from './components/CookieNotice';
import CompareModal             from './components/CompareModal';
import CallMeFormButton         from './components/buttons/CallMeFormButton';
import CallMeFormGratitudeModal from './components/CallMeFormGratitudeModal';
import DealerRequestModal       from './components/DealerRequestModal';
import { Footer }               from './components/footer';
import Header                   from './components/Header';
import HeaderBanner             from './components/HeaderBanner';
import LightBox                 from './components/lightBox';
import Modal                    from './components/modal';
import Notification             from './components/Notification';
import NotificationModal        from './components/NotificationModal';
import ScrollTop                from './components/buttons/ScrollTop';
import Search                   from './components/containers/Search';
import ShareModal               from './components/ShareModal';
import { StartupLoading }       from './components/loader/startupLoading';

import { useCatalog }   from './providers/catalog';
import { useCommon }    from './providers/common';
import { useUser }      from './providers/user';
import Routes           from './routes';

const Wrapper = () => {
  const { t } = useTranslation();

  const {
          getCatalogFilterInitialState,
          filter,
        }        = useCatalog();
  const {
          getRoutes,
          ...common
        }        = useCommon();
  const {
          getUserInfo,
          getAuthToken,
          ...user
        }        = useUser();

  const initialStateLoaded =
          user.userInitialStateLoaded || filter.initialStateLoaded;

  React.useEffect(() => {
    const initialData  = document.body.querySelector(
      '[data-js-react-on-rails-store]',
    );
    const reactContext = document.getElementById('js-react-on-rails-context');
    const component    = document.body.querySelector(
      '.js-react-on-rails-component',
    );

    if (t('bitrix_widget_script').length > 0) {
      setTimeout(() => {
        ;(
          function(w, d, u) {
            let s   = d.createElement('script');
            s.async = true;
            s.rel   = 'dns-prefetch';
            s.src   = u + '?' + (
              (
                Date.now() / 60000) | 0);
            let h   = d.getElementsByTagName('script')[0];
            h.parentNode.insertBefore(s, h);
          })(
          window,
          document,
          `https://steelline24.by/upload/crm/site_button/${t(
            'bitrix_widget_script',
          )}`,
        );
      }, 1e4);

      if (initialData) {
        initialData.parentNode.removeChild(initialData);
      }

      if (reactContext) {
        reactContext.parentNode.removeChild(reactContext);
      }

      if (component) {
        component.parentNode.removeChild(component);
      }

      if (!common.pagesLoaded) {
        getRoutes();
      }

      if (!user.userInitialStateLoaded) {
        getUserInfo();
      }

      if (!user.authorized && !DV.isString(user._token)) {
        getAuthToken();
      }

      if (!filter.initialStateLoaded) {
        getCatalogFilterInitialState();
      }
    }
  }, []);

  return (
    <>
      <div className={'page-wrapper'}>
        <section className={'sticky'}>
          {common.banners.length > 0 && (
            <HeaderBanner banners={common.banners} />
          )}
          <Header />
        </section>
        <Alerts />
        <Breadcrumbs />
        <DealerRequestModal />
        <Routes />
        <Footer />
        <Backdrop />
        <Modal />
        <LightBox />
        <ProfileSidebar />
        <CallMeSidebar />
        <ScrollTop />
        <Search />
        <div id={'modal-root'} />
        <Notification />
        <NotificationModal />
        <BottomMenu />
        <ShareModal />
        <CompareModal />
        <CallMeFormGratitudeModal />
        <CallMeFormButton />
        {initialStateLoaded && <CookieNotice />}
      </div>
      {!initialStateLoaded && <StartupLoading />}
    </>
  );
};

export default Wrapper;
